import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import moment from 'moment';

interface RequestFileState {
  id: any;
  company?: any;
  companyId?: any;
  workPlaceId?: any;
  workPlace?: any;
  contract?: any;
  contractId?: any;
  agentId?: any;
  agent?: any;
  statusId?: any;
  status?: any;
  number?: any;
  assignedTechnician?: any;
  assignedTechnicianId?: any;
  interventionDate?: any;
  interventionStart?: any;
  interventionEnd?: any;
  startingLatitude?: any;
  startingLongitude?: any;
  arrivalingLatitude?: any;
  arrivalingLongitude?: any;
  locationInfo?: any;
  remarks?: any;
  vehicle?: any;
  postBy?: any;
  elapsedTime?: any;
  traveledKm?: any;
  isUrgent?: any;
  requestFileSystemTypes: any[];
  telegramMessageId: any;
  isActive?: any;
  metadata?: any;
  props: {
    [key: string]: any;
  };
}

const currentDate = moment().format('YYYY-MM-DD');

const initialState: RequestFileState = {
  id: '',
  company: null,
  companyId: '',
  workPlace: null,
  workPlaceId: '',
  contract: null,
  contractId: '',
  agent: null,
  agentId: '',
  assignedTechnician: null,
  assignedTechnicianId: '',
  interventionDate: currentDate,
  locationInfo: '',
  remarks: '',
  isUrgent: false,
  isActive: false,
  vehicle: '',
  postBy: '',
  statusId: 1,
  status: null,
  number: null,
  startingLatitude: 0,
  startingLongitude: 0,
  arrivalingLatitude: 0,
  arrivalingLongitude: 0,
  interventionStart: currentDate,
  interventionEnd: currentDate,
  elapsedTime: 0,
  traveledKm: 0,
  requestFileSystemTypes: [],
  telegramMessageId: null,
  metadata: null,
  props: { searchTerm: '', skip: 1, take: 10, totalItems: 0, searchStatus: '' },
};

const requestFileSlice = createSlice({
  name: 'requestFile',
  initialState,
  reducers: {
    setRequestFile: (state, action: PayloadAction<Partial<RequestFileState>>) => {
      return { ...state, ...action.payload };
    },
    updateField: (state: any, action: PayloadAction<{ field: any; value: any }>) => {
      const { field, value } = action.payload;
      state[field] = value;
    },
    updateProps: (state, action: PayloadAction<{ field: string; value: any }>) => {
      const { field, value } = action.payload;
      state.props = {
        ...state.props,
        [field]: value,
      };
    },
  },
});

export const { setRequestFile, updateField, updateProps } = requestFileSlice.actions;

export default requestFileSlice.reducer;
